import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

const Root = ReactDOM.createRoot(document.getElementById("root"));

Root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorker.register();

reportWebVitals();
